import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'rebass';

const TinyButton = ({ children, height, ...props }) => (
  <Button
    style={{
      lineHeight: 1,
      minHeight: height,
      height,
      padding: 5,
      fontSize: 9,
    }}
    p={1}
    {...props}
  >
    {children}
  </Button>
);

TinyButton.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.number,
};

TinyButton.defaultProps = {
  height: 20,
};

export default TinyButton;
